import { Omit, Text } from 'bold-ui'
import { useTipoRegistroAfetadoSelectFieldQuery } from 'graphql/hooks.generated'
import { TipoRegistroAfetadoSelectFieldQuery } from 'graphql/types.generated'
import React from 'react'

import { SelectField, SelectFieldProps } from '../../../final-form'

export type TipoRegistroSelectModel = TipoRegistroAfetadoSelectFieldQuery['auditoriaTipoRegistroAfetado'][0]

export interface TipoRegistroProps extends Omit<SelectFieldProps<TipoRegistroSelectModel>, 'items' | 'itemToString'> {}

export interface TipoRegistroAfetadoVariables {}

export function TipoRegistroAfetadoSelectField(props: TipoRegistroProps) {
  const { data } = useTipoRegistroAfetadoSelectFieldQuery({
    fetchPolicy: 'cache-first',
  })

  if (!data) {
    return null
  }

  const itemToString = (item: TipoRegistroSelectModel) => item && item.nome

  const renderItem = (item: TipoRegistroSelectModel) => {
    return <Text>{item.nome}</Text>
  }
  return (
    <SelectField<TipoRegistroSelectModel>
      items={data.auditoriaTipoRegistroAfetado}
      itemToString={itemToString}
      renderItem={renderItem}
      {...props}
    />
  )
}
